
<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{ title }}
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" (click)="closeDialog()">
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div class="nova-grid-container">
    <nova-grid #grid
        [data]="data$ | async"
        [args]="fetchArgs$ | async"
        [isLoading]="isLoading$ | async"
        [defaultFetchArgs]="defaultFetchArgs"
        [resizable]="true"
        [filterable]="true"
        [reorderable]="true"
        (dataNeeded)="load($event)"
        (rowSelected)="rowSelected($event)"
        [autoFitColumns]="false"
        [directExportToExcel]="false"
        [pageable]="true"
        [needToolbar]="false"
        [singleSelection]="true"
        [selectable]="{ enabled: true, mode: 'single' }">

        <nova-grid-column field="id"
            title="Margin Id"
            [template]="marginTemplate"
            [filterTemplate]="emptyFilterTemplate"
            [filterCellTemplate]="marginIdFilterCellTemplate"
            [sortable]="true"
            width="30">
            <ng-template let-dataItem="dataItem" #marginTemplate>
                <a class="app-cursor-pointer a-blue" (click)="onMarginIdClick(dataItem)">{{ dataItem.id }}</a>
            </ng-template>
            <ng-template let-filter="filter" #marginIdFilterCellTemplate>
                <grid-filter-layout>
                    <ng-template #quickFilter>
                        <grid-text-filter
                            [filter]="filter"
                            field="id"
                            [filterService]="grid.filterService"
                            class="app-nova-grid-text-filter">
                        </grid-text-filter>
                    </ng-template>
                    <ng-template #popupFilter>
                        <grid-clear-filter-popup
                            title="Margin Id"
                            field="id"
                            [filter]="filter"
                            [filterService]="grid.filterService">
                        </grid-clear-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="candidateName"
            title="Candidate Name"
            [sortable]="true"
            [filterTemplate]="emptyFilterTemplate" 
            [filterCellTemplate]="candidateNameFilterCellTemplate"
            width="50">
            <ng-template #candidateNameFilterCellTemplate let-filter="filter" let-filterService="filterService">
                <grid-filter-layout>
                    <ng-template #quickFilter>
                        <grid-text-filter field="candidateName" [filter]="filter" [filterService]="filterService">
                        </grid-text-filter>
                    </ng-template>
                    <ng-template #popupFilter>
                        <grid-clear-filter-popup field="candidateName" [filter]="filter" [filterService]="filterService">
                        </grid-clear-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            title="Facility Id"
            field="facilityId"
            [hidden]="true"
            width="30">
        </nova-grid-column>

        <nova-grid-column
            title="Candidate Id"
            field="candidateId"
            [hidden]="true"
            width="30">
        </nova-grid-column>

        <nova-grid-column field="expertiseName"
            title="Specialty"
            [sortable]="true"
            [filterCellTemplate]="specialtyFilterCellTemplate"
            width="50">
            <ng-template #specialtyFilterCellTemplate let-filter="filter" let-filterService="filterService">
                <grid-filter-layout class="specialty-filter">
                    <ng-template #popupFilter>
                        <grid-specialty-filter-popup
                            field="expertiseId"
                            [filter]="filter"
                            [filterService]="filterService"
                            [specialties]="lookupExpertises$ | async">
                        </grid-specialty-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="baseRate"
            title="Rate"
            width="30"
            [sortable]="true"
            [template]="baseRateTemplate">
            <ng-template #baseRateTemplate let-dataItem="dataItem">
                {{ dataItem.baseRate | currency }}
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="marginPct"
            title="Margin %"
            width="30"
            [sortable]="true"
            [template]="marginPercentTemplate">
            <ng-template #marginPercentTemplate let-dataItem="dataItem">
                {{ dataItem.marginPct }}%
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="weeklyPay"
            title="Pay"
            width="25"
            [sortable]="true"
            [template]="weeklyPayTemplate">
            <ng-template #weeklyPayTemplate let-dataItem="dataItem">
                {{ dataItem.weeklyPay | currency }}
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="status"
            title="Status"
            width="20"
            [sortable]="true"
            [filterCellTemplate]="statusFilterCellTemplate">
            <ng-template #statusFilterCellTemplate let-filter="filter" let-filterService="filterService">
                <grid-filter-layout class="margin-status-filter">
                    <ng-template #popupFilter>
                        <grid-option-list-filter-popup
                            field="statuses"
                            [filter]="filter"
                            [filterService]="filterService"
                            [width]="300"
                            [options]="statusOptions">
                        </grid-option-list-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="shiftTime"
            title="Shift Time"
            [sortable]="true"
            width="20">
        </nova-grid-column>

        <nova-grid-column
            field="numberOfShifts"
            title="# Of Shifts"
            [sortable]="true"
            width="20">
        </nova-grid-column>

        <nova-grid-column
            field="startDate"
            title="Start Date"
            [sortable]="true"
            [template]="startDateTemplate"
            width="25">
            <ng-template #startDateTemplate let-dataItem="dataItem">
                {{ dataItem.startDate | lenientDate:'MM/dd/yyyy':true }}
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="endDate"
            title="End Date"
            [sortable]="true"
            [template]="endDateTemplate"
            width="25">
            <ng-template #endDateTemplate let-dataItem="dataItem">
                {{ dataItem.endDate | lenientDate:'MM/dd/yyyy':true }}
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="assignedLength"
            title="Assign. Length"
            [sortable]="true"
            width="20">
        </nova-grid-column>

        <nova-grid-column
            field="hasBenefits"
            title="Benefits"
            [sortable]="true"
            [template]="hasBenefitsTemplate"
            width="20">
            <ng-template #hasBenefitsTemplate let-dataItem="dataItem">
                <span *ngIf="dataItem.hasBenefits !== null">
                    <mat-icon *ngIf="dataItem.hasBenefits" class="md-18">done</mat-icon>
                </span>
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="hasHousing"
            title="Housing"
            [sortable]="true"
            [template]="hasHousingTemplate"
            width="20">
            <ng-template #hasHousingTemplate let-dataItem="dataItem">
                <span *ngIf="dataItem.hasHousing !== null">
                    <mat-icon *ngIf="dataItem.hasHousing" class="md-18">done</mat-icon>
                </span>
            </ng-template>
        </nova-grid-column>

        <nova-grid-column
            field="createdDate"
            title="Created"
            [sortable]="true"
            [template]="dateCreatedTemplate"
            width="25">
            <ng-template #dateCreatedTemplate let-dataItem="dataItem">
                {{ dataItem.createdDate | lenientDate:'MM/dd/yyyy':true }}
            </ng-template>
        </nova-grid-column>

        <ng-template #emptyFilterTemplate></ng-template>
    </nova-grid>
</div>
<div class="action-btn-container">
    <button mat-raised-button color="primary" (click)="importMargin()"
        class="next-btn next-btn--margin-right"
        [disabled]="isImportMarginButtonDisabled || isImporting">
        <span>IMPORT MARGIN</span>
    </button>
    <button mat-raised-button color="default" (click)="closeDialog()">
        CANCEL
    </button>
</div>
